if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const target = event.target.closest('.share-button__item--copy');
        if (target) {
          event.preventDefault();
          const dataHref = target.getAttribute('href');
          navigator.clipboard
            .writeText(dataHref)
            .then(() => {
              this.showTooltip(target);
            })
            .catch((err) => {
              console.error('Failed to copy:', err);
            });
        }
      }

      showTooltip(element) {
        let tooltip = document.querySelector('.tooltip');
        if (!tooltip) {
          console.error('Tooltip element not found in the template.');
          return;
        }

        tooltip.classList.add('active');

        setTimeout(() => {
          tooltip.classList.remove('active');
        }, 700);
      }
    }
  );
}